// PrivateCouncilTheThreshold.jsx

import React from "react";
import { motion } from "framer-motion";
import { Container } from "react-bootstrap";
import "../../asstes/styles/privateCouncilWhoSheeks.scss";
import Who_Seeks_1 from "../../asstes/images/private-council/WhoSeeks-1.jpg";
import Who_Seeks_2 from "../../asstes/images/private-council/WhoSeeks-2.jpg";
import Who_Seeks_3 from "../../asstes/images/private-council/WhoSeeks-3.jpg";
import {
  Crown,
  ShieldCheck,
  UserRound,
  ArrowRight,
  Sparkles,
} from "lucide-react";

const cardVariants = {
  hidden: { opacity: 0, y: 80 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.2,
      duration: 0.8,
      ease: "easeOut",
    },
  }),
};

const cards = [
  {
    id: "01",
    title: "Final Authority",
    description:
      "You carry the final say. The buck stops with you — and the outcome is yours to own, without dilution.",
    image: Who_Seeks_1,
    icon: <Crown size={34} />,
  },
  {
    id: "02",
    title: "Irreversible Consequence",
    description:
      "The decisions you face cannot be undone — only carried forward. Precision is not optional.",
    image:Who_Seeks_2,
    icon: <ShieldCheck size={34} />,
  },
  {
    id: "03",
    title: "No Delegation Left",
    description:
      "No board, role, consultant, or framework can absorb what must be carried next.",
    image:Who_Seeks_3,
    icon: <UserRound size={34} />,
  },
];

const PrivateCouncilWhoSheeks = () => {
  return (
    <section className="threshold-section pd-common">
      <Container>
        <div className="bg-grid"></div>
 

      {/* HEADER */}
      <motion.div
  className="heading-wrapper"
  initial={{ opacity: 0, y: -40 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.8 }}
  viewport={{ once: true }}
>
  <motion.span
    className="mini-title"
    initial={{ opacity: 0, letterSpacing: "2px" }}
    whileInView={{ opacity: 1, letterSpacing: "5px" }}
    transition={{ duration: 0.8 }}
    viewport={{ once: true }}
  >
    CRITERIA FOR ENGAGEMENT
  </motion.span>

  <motion.h2
    className="pc-heading-title"
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{
      duration: 0.8,
      delay: 0.2,
      ease: "easeOut",
    }}
    viewport={{ once: true }}
  >
    Who Seeks <span>This</span>
  </motion.h2>

  <motion.p
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{
      duration: 0.8,
      delay: 0.4,
      ease: "easeOut",
    }}
    viewport={{ once: true }}
  >
    The Private Council is for individuals who hold final authority over
    consequential decisions, cannot outsource the cost of deciding, and
    operate at a level where errors cannot be quickly corrected.
  </motion.p>

  <motion.p
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{
      duration: 0.8,
      delay: 0.6,
      ease: "easeOut",
    }}
    viewport={{ once: true }}
  >
    It is sought across enterprise, leadership, capital, influence,
    institutional power, and personal authority when consensus has become
    a shield and delay has become a decision in disguise.
  </motion.p>
</motion.div>

      {/* CARDS */}
      <div className="cards-wrapper">
        {cards.map((card, index) => (
          <motion.div
            className="threshold-card"
            key={index}
            custom={index}
            variants={cardVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            whileHover={{
              y: -10,
            }}
          > 
            <div className="card-icon">{card.icon}</div>  
            <div className="card-image">
              <img src={card.image} alt={card.title} />
              <div className="overlay"></div>
            </div> 
            <div className="card-content">
              <div>
                <span className="card-number">{card.id}</span> 
                <h3 className="card-title">{card.title}</h3> 
                <div className="small-line"></div> 
                <p>{card.description}</p>
              </div> 
            </div>
          </motion.div>
        ))}
      </div>
 
      </Container>
    </section>
  );
};

export default PrivateCouncilWhoSheeks;